import styled from '@emotion/styled';
import { Flex } from 'react-magma-dom';
import { COLORS } from '../../constants';

export const StyledFlexAddCode = styled(Flex)`
  width: 950px;
  height: 760px;
  border-radius: 0 10px 10px 0;
  background-color: white;

  @media (max-width: 1290px) {
    width: 832px;
  }

  @media (max-width: 1190px) {
    width: 660px;
  }

  @media (max-width: 1023px) {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
`;

export const StyledEmailContainer = styled.div`
  width: 731px;
  height: 124px;
  padding: 24px 0;
  margin: 0 auto 36px;
  opacity: 0.9;
  border-radius: 4px;
  background-color: ${COLORS.extraLightGray};

  @media (max-width: 1190px) {
    width: 100%;
  }
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    padding: 16px;
    margin: 0 auto 20px;
  }
`;

export const StyledEmail = styled.div`
  font-size: 30px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: ${COLORS.seaBlue};
  @media (max-width: 768px) {
    font-size: 24px;
  }

  @media (max-width: 414px) {
    font-size: 20px;
  }
`;
